import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { getCookie } from "../../slidebar/components/DarkMode";
import * as actions from "../redux/VipHistoryAction";

export const VipHistoryDetail = ({ commid, setCommid, setSwalProps }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const vipHistoryState = useSelector(
    ({ vipHistory }) => vipHistory,
    shallowEqual
  );

  const handleClose = () => setCommid(undefined);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    if (commid) {
      const queryParams = {
        action: "vipcommhistorydetail",
        commid,
      };
      dispatch(actions.fetchVipHistoryDetail(queryParams)).then((resp) => {
        resp = resp.data;
        if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      });
    }
  }, [commid]);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        show={!!commid}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "vipHistoryDetail",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="member-div d-flex"
            style={{
              margin: "10px auto",
            }}
          >
            <div className="member-container">
              <div className="table-responsive">
                <table className="member-table">
                  <thead className="member-header1">
                    <tr className="member-row1">
                      <th className="member-cell hide-on-mobile">
                        {intl.formatMessage({ id: "no" })}
                      </th>
                      <th className="member-cell text-start text-nowrap">
                        {intl.formatMessage({ id: "username" })}
                      </th>
                      <th className="member-cell text-start text-nowrap">
                        {intl.formatMessage({ id: "regardingOn" })}
                      </th>
                      <th className="member-cell text-nowrap text-end">
                        {intl.formatMessage({ id: "commissionNumber" })}
                      </th>
                      <th className="member-cell text-nowrap text-end">
                        {intl.formatMessage({ id: "balance" })}
                      </th>
                      <th className="member-cell text-nowrap text-start">
                        {intl.formatMessage({ id: "gameType" })}
                      </th>
                      <th className="member-cell text-nowrap text-start">
                        {intl.formatMessage({ id: "isEdited" })}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="member-body">
                    {vipHistoryState.vipHistoryDetail?.vipCommHistoryDetails &&
                    vipHistoryState.vipHistoryDetail.vipCommHistoryDetails
                      .length > 0 ? (
                      vipHistoryState.vipHistoryDetail.vipCommHistoryDetails.map(
                        (report, index) => (
                          <tr key={index} className="member-row1">
                            <td className="member-cell hide-on-mobile">
                              {index + 1}
                            </td>
                            <td className="member-cell text-start">
                              {report.username}
                            </td>
                            <td className="member-cell text-start">
                              {report.regardingon}
                            </td>
                            <td className="member-cell text-end">
                              {report.commnumber}
                            </td>
                            <td className="member-cell text-end">
                              {report.commbalance}
                            </td>
                            <td className="member-cell">{report.gametype}</td>
                            <td className="member-cell">{report.isedited}</td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan="7">
                          <div className="no-record-wrapper oRecordDiv">
                            <i className="bi bi-search fs-1 mb-3" />
                            <div className="text-font2">
                              {intl.formatMessage({ id: "noRecordFound" })}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
